/**
 * Reown AppKit config for Pokémon CRM.
 * Imported once in App.js so Trust Wallet iOS can connect through Reown / WalletConnect.
 */
import { createAppKit } from "@reown/appkit/react";
import { EthersAdapter } from "@reown/appkit-adapter-ethers";
import { defineChain } from "@reown/appkit/networks";

const projectId =
    process.env.REACT_APP_REOWN_PROJECT_ID ||
    process.env.REACT_APP_WALLETCONNECT_PROJECT_ID ||
    "489171facb1e39390de7264eab466ef0";

const bsc = defineChain({
    id: 56,
    caipNetworkId: "eip155:56",
    chainNamespace: "eip155",
    name: "BNB Smart Chain",
    nativeCurrency: {
        decimals: 18,
        name: "BNB",
        symbol: "BNB",
    },
    rpcUrls: {
        default: { http: ["https://bsc-dataseed1.binance.org/"] },
    },
    blockExplorers: {
        default: { name: "BscScan", url: "https://bscscan.com" },
    },
});

const metadata = {
    name: "PokeDao CRM",
    description: "PokeDao CRM Wallet Connect",
    url: typeof window !== "undefined" ? window.location.origin : "https://pokemoncrm.madxpanel.com",
    icons: [typeof window !== "undefined" ? `${window.location.origin}/favicon.ico` : "https://pokemoncrm.madxpanel.com/favicon.ico"],
};

if (projectId) {
    createAppKit({
        adapters: [new EthersAdapter()],
        networks: [bsc],
        defaultNetwork: bsc,
        projectId,
        metadata,
        features: {
            analytics: false,
            swaps: false,
            onramp: false,
            email: false,
            socials: false,
            emailShowWallets: false,
        },
    });
} else if (process.env.NODE_ENV !== "production") {
    console.warn("[Reown] REACT_APP_REOWN_PROJECT_ID / REACT_APP_WALLETCONNECT_PROJECT_ID is not set.");
}
